/* eslint-disable react-doctor/only-export-components */
import { IconArrowRight } from "@tabler/icons-react";
import { createFileRoute, Link } from "@tanstack/react-router";
import {
	DocsCenterLayout,
	DocsCenterSidebar,
} from "@/components/docs/docs-center-layout";
import { config } from "@/data/config";
import { getKnowledgeBaseNavSections } from "@/lib/docs-content";
import { docsKnowledgeBaseLink } from "@/lib/docs-paths";
import { redirectIfModuleDisabled } from "@/lib/module-guards";
import { seo } from "@/utils/seo";

export const Route = createFileRoute("/_docs/docs/knowledge-base/")({
	beforeLoad: () => redirectIfModuleDisabled("knowledge_base", "/"),
	head: () =>
		seo({
			title: "Knowledge base",
			description: `Short references for ${config.siteName} API scopes, roles, and common lookups.`,
			keywords: "knowledge base, api scopes, permissions",
		}),
	component: KnowledgeBaseHomePage,
});

function KnowledgeBaseHomePage() {
	const sections = getKnowledgeBaseNavSections();
	const articles = sections.flatMap((section) => section.items);

	return (
		<DocsCenterLayout
			mobileNavTitle="Knowledge base"
			sidebar={
				<DocsCenterSidebar
					title="Knowledge base"
					description="Short reference articles"
					sections={sections}
					activeSlug={null}
					linkForSlug={docsKnowledgeBaseLink}
				/>
			}
		>
			<div className="mx-auto w-full max-w-3xl space-y-8">
				<header className="space-y-2">
					<h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">
						Knowledge base
					</h1>
					<p className="text-muted-foreground">
						Quick lookups for scopes, roles, and other details pulled from the
						product and API reference.
					</p>
				</header>

				<div className="grid gap-3">
					{articles.map((article) => (
						<Link
							key={article.slug}
							{...docsKnowledgeBaseLink(article.slug)}
							className="group flex items-start justify-between gap-4 rounded-lg border border-border px-4 py-3 transition-colors hover:bg-muted/40"
						>
							<div className="min-w-0 space-y-1">
								<p className="font-medium text-foreground group-hover:text-primary">
									{article.title}
								</p>
								{article.summary ? (
									<p className="text-sm text-muted-foreground">
										{article.summary}
									</p>
								) : null}
							</div>
							<IconArrowRight className="mt-0.5 size-4 shrink-0 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
						</Link>
					))}
				</div>
			</div>
		</DocsCenterLayout>
	);
}
